module.exports = __webpack_public_path__ + "img/circle.d255a4f8.svg";